import { EThemeName, IThemeProperty, IThemesConfig } from '@wind-log_library/fe-component-library';
import { environment } from 'src/environments/environment';

export interface Theme {
  name: string;
  properties: any;
}

const FILE_SERVER_BASE_URL = environment.shared_server + '/fe-component-library/';
const FILE_SERVER_MAIN_INTERFACE = environment.shared_server + '/general/main-interface/';

export const light: IThemeProperty = {
  name: EThemeName.LIGHT,
  properties: {
    '--primary': '#1A1A1A',
    '--primary-inverse': '#ffffff',
    '--primary-inactive': '#D1D4DE',
    '--secondary': '#88c0e3',
    '--secondary-inactive': '#ff0000',
    '--hover': '#F4F5F7',
    '--tertiary': '#85a3b6',
    '--background': '#F6F6F9',
    '--background-export': '#F6F6F9',
    '--font': '#9e9e9e',
    '--white': '#ffffff',
    '--black': '#000000',
    '--gray100': '#D1D4DE',
    '--red': '#dc3545',
    '--yellow': '#ffc107',
    '--green': '#28a745',
    '--scatter-plot': '#1A1A1A',
    '--primary-button': '#009FDA',
    '--nav-checkbox': '#ECEEF1',
    '--card': '#ffffff',
    '--divider': '#dfdfdf',
    '--transparent': 'transparent',
    '--table-odd-row': '#EEF1F5',
    '--scrollbar': '#F6F6F9',
    '--scrollbar-active': '#D1D4DE',
    '--time-range-button-border': '#3E7ABE',
    '--time-range-button': '#E6F5FB',
    '--theme-switch': '#c2d1da',
    '--theme-switch-handle': '#009FDA',
    '--theme-switch-icon': 'url("' + FILE_SERVER_BASE_URL + 'general-icons/theme/Theme_Light_Mode.svg")',
    '--toggle-button-background-active': '#E8F8F5',
    '--toggle-button-background': '#FFFFFF',
    '--primary-background': '#009FDA',
    '--primary-background-selected': '#007FAE',
    '--navigation-border': '#E9ECEF',
    '--graph': '#f2f5f7',
    '--primary-opposite': '#ffffff',
    '--gray-600': '#868e96',
    '--primary-button-hover': '#0285b5',
    '--primary-button-active': '#009FDA',
    '--scroll-bar': '#D1D4DE',
    '--scroll-background': '#F6F6F9',
    '--gray': '#888889',
    '--dropdown-background': '#F6F6F9',
    '--inactive-label-text-color': '#1A1A1A60',
    '--mat-tab-inactive-label-text-color': '#1A1A1A60',
    '--mat-tab-inactive-hover-label-text-color': '#1A1A1A90',
    '--mat-tab-active-label-text-color': '#1A1A1A90',
    '--mat-form-field-outlined-outline-color': '#E9ECEF',
    '--mat-form-field-outlined-focus-outline-color': '#009FDA',
    '--mat-form-field-outlined-input-text-color': '#1A1A1A',
    '--inactive-hover-label-text-color': '#1A1A1A90',
    '--availability-forecast': '#33BD33',
    '--input-text': '#1A1A1A',
    '--input-border': '#ADB5BD',
    '--input-background': '#ffffff',
    '--input-disabled-background': '#f8f9fa',
    '--filter-button-hover': '#E6E6E6',
    '--warning-message-background': '#FFFBE6',
    '--warning-message-icon': '#EBCB5C',
    '--warning-message-border': '#D5C468',
    '--secondary-button': '#DFE0E8',
    '--secondary-button-hover': '#DADBE1',
    '--secondary-button-active': '#CECFD5',
    '--secondary-button-disabled': '#F5F5F8',
    '--map-info': '#1F4C28B3',
    '--map-img': '#00000052',
    '--accent': '#3e7abe',
    '--accent-button': '#009FDA',
    '--accent-button-hover': '#007FAE',
    '--switch-background': '#9e9e9e',
    '--background-primary-secondary': '#EDF5FD',
    '--notification-background': '#EFF7EE',
    '--notification-border': '#3F9C35',
    '--notification-red-text': '#DC3545',
    '--notification-red': '#F8D7DA',
    '--notification-warning-border': '#FFC107',
    '--notification-warning-background': '#FFFDE1',
    '--expand-icon': 'url("' + FILE_SERVER_MAIN_INTERFACE + 'icon-expand-light.svg")',
    '--shrink-icon': 'url("' + FILE_SERVER_MAIN_INTERFACE + 'icon-shrink-light.svg")',
    '--new-row': '#EDF5FD',
    '--notification-green-text': '#00C875',
    '--notification-green-light': '#EFF7EE',
    '--notification-green-dark': '#3F9C35',
    '--notification-red-light': '#F8D7DA',
    '--notification-red-dark': '#421015',
    '--notification-info': '#ebf0fd',
    '--notification-info-text': '#091b47',
    '--card-shadow': '#00000033',
    '--modal-background': '#F8F9FA',
    '--gray-background': '#F8F9FA',
    '--tabs-background-primary': '#edf5fd',
    '--tabs-background-primary-selected': '#ccecf8',
    '--default-power-curve': '#D2B156',
    '--weather-icon': 'grayscale(1)',
    '--RANGE_0_3': '#C8E9B4',
    '--RANGE_3_6': '#7FCDBB',
    '--RANGE_6_9': '#41B5C4',
    '--RANGE_PLUS_9': '#1D91C0',
    '--error-background': '#FDE8E9',
    '--mast-shadow': '#CEB619',
    '--coverage-table-red': '#EB2A34',
    '--coverage-table-yellow': '#E28545',
    '--coverage-table-green': '#3F9C35',
    '--dark-gray': '#ADB5BD',
    '--table-text-gray': '#636669',
    '--header-dropdown-item-hover': '#f8f9fa',
    '--datepicker-in-range-background': '#e9edf0',
    '--bulk-actions-background': '#edf5fd',
    '--group-text': '#495057',
    '--exclusion': '#CCECF880',
    '--download-all-background': '#ffffff',
    '--expanded-row': '#f9fafb',
    '--chart-lines': '#e6e6e6',
    '--info-message-background': '#E6F8FF',
    '--info-message-icon': '#33C8FF',
    '--info-message-border': '#33C8FF',
    '--text-gray': '#636669',
    '--validation-error': '#EB2A34',
    '--min-max-diurnal-wind-shear-area': '#edf5fdb3',
    '--export-button-border': '#dee2e6',
    '--chip-container': '#f8f9fa',
    '--alarm-time': '#636669',
    '--new-item-background': '#f5f5f5',
    '--country-card-divider': '#dee2e6',
    '--country-card-border': '#dee2e6',

    // mat-pagination
    '--mat-paginator-container-text-color': '#1A1A1A',
    '--mat-paginator-enabled-icon-color': '#1A1A1A',
    '--mat-paginator-disabled-icon-color': '#1A1A1A80',
    '--mat-paginator-container-background-color': '#ffffff',
    '--mat-select-panel-background-color': '#ffffff',
    '--mat-select-enabled-trigger-text-color': '#1A1A1A',
    '--mat-select-disabled-trigger-text-color': '#1A1A1A',
    '--mat-select-placeholder-text-color': '#1A1A1A',
    '--mat-select-enabled-arrow-color': '#1A1A1A',
    '--mat-select-disabled-arrow-color': '#1A1A1A',
    '--mat-select-focused-arrow-color': '#1A1A1A',
    '--mdc-outlined-text-field-focus-outline-color': '#1A1A1A',
    '--mat-option-selected-state-label-text-color': '#1A1A1A',
    '--mat-option-label-text-color': '#1A1A1A80',
    '--mdc-outlined-text-field-outline-color': '#1A1A1A',
    '--mat-option-selected-state-layer-color': '#edf5fd',
    '--ts-button-bg': '#EEF1F5',
    '--ts-content-bg': '#F5F8F9',
  },
};

export const dark: IThemeProperty = {
  name: EThemeName.DARK,
  properties: {
    '--primary': '#ffffff',
    '--primary-inverse': '#1A1A1A',
    '--secondary': '#88c0e3',
    '--hover': '#192431',
    '--tertiary': '#85a3b6',
    '--background': '#00040a',
    '--background-export': '#343A40',
    '--font': '#9e9e9e',
    '--white': '#ffffff',
    '--black': '#000000',
    '--gray100': '#D1D4DE',
    '--red': '#dc3545',
    '--yellow': '#ffc107',
    '--green': '#28a745',
    '--scatter-plot': '#ffc107',
    '--primary-button': '#009FDA',
    '--nav-checkbox': '#2B323B',
    '--card': '#131b25',
    '--divider': '#374c5d',
    '--transparent': 'transparent',
    '--table-odd-row': '#1F2831',
    '--scrollbar': '#353E46',
    '--scrollbar-active': '#4C535A',
    '--theme-switch': '#4c5f6e',
    '--theme-switch-handle': '#009FDA',
    '--theme-switch-icon': 'url("' + FILE_SERVER_BASE_URL + 'general-icons/theme/Theme_Dark_Mode.svg")',
    '--toggle-button-background-active': '#05251F',
    '--toggle-button-background': '#131B25',
    '--primary-background': '#009FDA',
    '--primary-background-selected': '#007FAE',
    '--navigation-border': '#2B323B',
    '--graph': '#2e5067',
    '--primary-opposite': '#1A1A1A',
    '--gray-600': '#868e96',
    '--primary-button-hover': '#1B5698',
    '--primary-button-active': '#1B5698',
    '--scroll-bar': '#4C535A',
    '--scroll-background': '#353E46',
    '--gray': '#9E9E9E',
    '--dropdown-background': '#424951',
    '--inactive-label-text-color': '#ffffff60',
    '--mat-tab-inactive-label-text-color': '#ffffff60',
    '--mat-tab-inactive-hover-label-text-color': '#ffffff90',
    '--mat-tab-active-label-text-color': '#ffffff60',
    '--mat-form-field-outlined-outline-color': '#2B323B',
    '--mat-form-field-outlined-focus-outline-color': '#1B5698',
    '--mat-form-field-outlined-input-text-color': '#ffffff',
    '--inactive-hover-label-text-color': '#ffffff90',
    '--availability-forecast': '#33BD33',
    '--input-text': '#1A1A1A',
    '--input-border': '#2B323B',
    '--input-background': '#353E46',
    '--input-disabled-background': '#424951',
    '--filter-button-hover': '#9E9E9E',
    '--time-range-button': '#009fda1a',
    '--time-range-button-border': '#3E7ABE',
    '--availability': '#246428',
    '--event-start': '#48AA48',
    '--event-end': '#C84C57',
    '--calendar-past': '#242E3A',
    '--warning-message-background': '#DFD5A0',
    '--warning-message-icon': '#C09F2D',
    '--warning-message-border': '#D5C468',
    '--secondary-button': '#424951',
    '--secondary-button-hover': '#3B4249',
    '--secondary-button-active': '#353A41',
    '--secondary-button-disabled': '#141618',
    '--map-info': '#1F4C28B3',
    '--map-img': '#00000052',
    '--accent': '#3e7abe',
    '--accent-button': '#009FDA',
    '--accent-button-hover': '#007FAE',
    '--switch-background': '#9e9e9e',
    '--background-primary-secondary': '#404f5f',
    '--notification-background': '#EFF7EE',
    '--notification-border': '#3F9C35',
    '--notification-red': '#421015',
    '--expand-icon': 'url("' + FILE_SERVER_MAIN_INTERFACE + 'icon-expand-dark.svg")',
    '--shrink-icon': 'url("' + FILE_SERVER_MAIN_INTERFACE + 'icon-shrink-dark.svg")',
    '--new-row': '#7f90a0',
    '--notification-green-text': '#00C875',
    '--notification-green-light': '#CCF4E3',
    '--notification-green-dark': '#003C23',
    '--notification-red-text': '#DC3545',
    '--notification-red-light': '#F8D7DA',
    '--notification-red-dark': '#421015',
    '--notification-info': '#ebf0fd',
    '--notification-info-text': '#091b47',
    '--notification-warning-border': '#FFC107',
    '--notification-warning-background': '#3A3520',
    '--card-shadow': '#fffbfb33',
    '--modal-background': '#121212',
    '--gray-background': '#424951',
    '--tabs-background-primary': '#004057',
    '--tabs-background-primary-selected': '#00202c',
    '--default-power-curve': '#D2B156',
    '--weather-icon': 'grayscale(1) brightness(1000%)',
    '--RANGE_0_3': '#C8E9B4',
    '--RANGE_3_6': '#7FCDBB',
    '--RANGE_6_9': '#41B5C4',
    '--RANGE_PLUS_9': '#1D91C0',
    '--mast-shadow': '#CEB619',
    '--coverage-table-red': '#EB2A34',
    '--coverage-table-yellow': '#E28545',
    '--coverage-table-green': '#3F9C35',
    '--dark-gray': '#343A40',
    '--table-text-gray': '#636669',
    '--header-dropdown-item-hover': '#ffffff1a',
    '--datepicker-in-range-background': '#495057',
    '--bulk-actions-background': '#004057',
    '--group-text': '#ffffff',
    '--error-background': '#662124',
    '--exclusion': '#004057',
    '--download-all-background': '#343A40',
    '--expanded-row': '#343A40',
    '--chart-lines': '#495057',
    '--info-message-background': '#E6F8FF',
    '--info-message-icon': '#33C8FF',
    '--info-message-border': '#33C8FF',
    '--text-gray': '#aeafb1',
    '--validation-error': '#EB2A34',
    '--min-max-diurnal-wind-shear-area': '#004057',
    '--export-button-border': '#212529',
    '--chip-container': '#343A40',
    '--alarm-time': '#ffffff',
    '--new-item-background': '#343A40',
    '--country-card-divider': '#212529',
    '--country-card-border': '#495057',

    // mat-pagination
    '--mat-paginator-container-text-color': '#ffffff',
    '--mat-paginator-enabled-icon-color': '#ffffff',
    '--mat-paginator-disabled-icon-color': '#ffffff80',
    '--mat-paginator-container-background-color': '#131b25',
    '--mat-select-panel-background-color': '#131b25',
    '--mat-select-enabled-trigger-text-color': '#ffffff',
    '--mat-select-disabled-trigger-text-color': '#ffffff',
    '--mat-select-placeholder-text-color': '#ffffff',
    '--mat-select-enabled-arrow-color': '#ffffff',
    '--mat-select-disabled-arrow-color': '#ffffff',
    '--mat-select-focused-arrow-color': '#ffffff',
    '--mdc-outlined-text-field-focus-outline-color': '#ffffff',
    '--mat-option-selected-state-label-text-color': '#ffffff',
    '--mat-option-label-text-color': '#ffffff80',
    '--mdc-outlined-text-field-outline-color': '#ffffff',
    '--mat-option-selected-state-layer-color': '#004057',
    '--ts-button-bg': '#314b6d',
    '--ts-content-bg': '#013648',
  },
};

export const themeConfig: IThemesConfig = {
  themeStoreName: 'wing-log-theme',
  config: [light, dark],
};
